<template>
  <div>
        <!-- 搜索框 -->
        <a-card size="small" title="站内信推送历史">
        </a-card>

        <channelSelecter :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter>

        <a-card size="small">
            <searchE ref="messageSearchTableID" @handleSearch="handleSubmit"></searchE>
            <tableE ref="messageRecordTableID"  :style="{width:tableWidth}"></tableE>
        </a-card>
  </div>
</template>
<script>
import tableE from './table'
import searchE from './search'
import channelSelecter from '../../components/channelSelecter'


export default {
    data() {
        return {
            searchP:{
                keyword:'',
                messageservicecode:'',
                channelcode:'',
                platformtype:'',
                messageid:''
            },
            tableWidth:'800px',
            channelcode:''
        };
    },
    methods: {
        handleChannelChange(item){
            this.channelcode = item.value;
            this.searchP.channelcode = item.value;
            this.$refs.messageSearchTableID.handleSubmit(this.searchP)
        },
        handleSubmit(searchP){
            searchP.channelcode = this.channelcode
            this.$refs.messageRecordTableID.handleSearch(searchP);
        },
        handleNew(){
            this.$router.push({
                path: "add_channel",
                query: {id:''}
            });
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },
    components:{
        tableE,
        searchE,
        channelSelecter
    },
    mounted(){
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);

    },
};
</script>
<style scoped>

</style>
